import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';

export interface FormValues {
  name: string;
  category: string;
  description: string;
  endpoint: string;
  user: string;
  password: string;
  licensePath: string;
  sftpIp: string;
  sftpUser: string;
  sftpPassword: string;
  sftpPath: string;
}

export const defaultValues: FormValues = {
  name: '',
  category: '',
  description: '',
  endpoint: '',
  user: '',
  password: '',
  licensePath: '',
  sftpIp: '',
  sftpUser: '',
  sftpPassword: '',
  sftpPath: ''
};

function setSchema() {
  return yup.object({
    name: yup.string().concat(yup.string().required('Name is required').min(1, 'Name cannot be empty')),
    category: yup.string().concat(yup.string().required('Category is required')),
    description: yup.string(),
    endpoint: yup.string().concat(
      yup
        .string()
        .required('Endpoint is required.')
        .matches(
          /^(?:(?:(?:https?:\/\/)?(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9]?[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9]?[0-9])(:\d{1,5})?)|(?:(?:https?:\/\/)?(?:[\da-z.-]+)\.(?:[a-z.]{2,6})(?:[/\w .-]*)*\/?))$/i,
          'Please enter a valid URL or a valid IPv4 address.'
        )
    ),
    user: yup.string().concat(yup.string().required('User Name is required.').min(1, 'User Name cannot be empty.')),
    password: yup.string().concat(yup.string().required('Password is required.').min(1, 'Password cannot be empty')),
    licensePath: yup.string().required('License path is required').min(1, 'License path must be at least 1 character'),
    sftpIp: yup
      .string()
      .required('SFTP IP is required')
      .matches(
        /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)(:\d{1,5})?$/,
        'Please enter a valid IPv4 address'
      ),
    sftpUser: yup.string().concat(yup.string().required('User Name is required.').min(1, 'User Name cannot be empty.')),
    sftpPassword: yup.string().concat(yup.string().required('Password is required.').min(1, 'Password cannot be empty')),
    sftpPath: yup.string().required('SFTP path is required').min(1, 'SFTP path must be at least 1 character')
  });
}

export function useMoshellForm(initialValues?: FormValues) {
  const schema = setSchema();
  return useForm({
    mode: 'onSubmit',
    resolver: yupResolver(schema),
    defaultValues: { ...defaultValues, ...initialValues }
  });
}
